export default "__VITE_ASSET__Dj5bIdiU__"